import React from 'react';
import { Button, Card, Form, Input, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import './styles.scss'
import { API_URL } from 'env';

const LoginPage = () => {
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    try {
      const response = await fetch(`${API_URL}api/v1/be/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });

      const data = await response.json();
      if (data.status) {
        localStorage.setItem('token', data.data.access_token);
        localStorage.setItem('userId', data.data.info.id);
        localStorage.setItem('userData', JSON.stringify(data.data));
        window.location.href = '/';
      } else {
        alert(data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('An error occurred while logging in.');
    }
    window.location.href = '/';
  };

  return (
    <div className="Login-page">
      <Card className="card-custom">
        <Typography.Title level={2} className="text-center text-gray-800 mb-6">
          Đăng Nhập
        </Typography.Title>
        <Form
          form={form}
          name="login_form"
          onFinish={onFinish}
          layout="vertical"
          initialValues={{ remember: true }}
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Vui lòng nhập Email!' }]}
          >
            <Input
              prefix={<UserOutlined className="text-gray-500" />}
              placeholder="Email"
              className="rounded-lg"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
          >
            <Input.Password
              prefix={<LockOutlined className="text-gray-500" />}
              placeholder="Mật khẩu"
              className="rounded-lg"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block className="h-10 rounded-lg bg-blue-600 hover:bg-blue-700">
              Đăng Nhập
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
